import { Card, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FilesOutline } from '@otp/icons';
import { ResourceListTable } from 'src/components/resource/list/list-table';
import { SortingDirection } from 'src/graphql/generated/graphql';

export const RecentResourcesCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card className="bg-[#F8F9FD] border-none w-full">
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        className="flex gap-2 items-center "
      >
        <FilesOutline />
        {t('resources.recent.title')}
      </Typography>

      <ResourceListTable
        isUserResources
        limit={3}
        withoutPagination
        defaultSorting={{
          updatedAt: SortingDirection.Desc,
        }}
        excludeColumns={['updatedAt', 'createdBy', 'actions']}
      />
    </Card>
  );
};
